import { useMemo } from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import brokerCompanyApi from '../../services/brokerCompanyApi';
import BrokerCompensationPanel from '../../components/broker/BrokerCompensationPanel';
import EmptyState from '../../components/shared/EmptyState';
import LoadingSkeleton from '../../components/shared/LoadingSkeleton';

const CompensationPage = () => {
  const { data: broker, isLoading: brokerLoading } = brokerCompanyApi.endpoints.getMyCompany.useQuery();
  const { data: offices = [], isLoading: officesLoading } = brokerCompanyApi.endpoints.getMyCompanyOffices.useQuery();

  const loading = brokerLoading || officesLoading;

  const companies = useMemo(() => {
    if (!broker) return [];
    return [
      { id: broker.id, name: broker.name, isParent: true },
      ...offices.map((o) => ({ id: o.id, name: o.name, isParent: false })),
    ];
  }, [broker, offices]);

  if (loading) {
    return <LoadingSkeleton variant="detail" />;
  }

  if (!broker) {
    return (
      <EmptyState
        icon={<ErrorOutlineIcon />}
        title="Company not found"
        description="Your account is not associated with a broker company."
      />
    );
  }

  return <BrokerCompensationPanel companies={companies} defaultCompanyId={broker.id} />;
};

export default CompensationPage;
